var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.625V9.0625H20.125V6.25C20.125 5.9375 19.8125 5.625 19.5 5.625H9.5ZM7.625 5.625H4.5C4.14844 5.625 3.875 5.9375 3.875 6.25V9.0625H7.625V5.625ZM3.875 10.9375V14.0625H7.625V10.9375H3.875ZM3.875 15.9375V18.75C3.875 19.1016 4.14844 19.375 4.5 19.375H7.625V15.9375H3.875ZM9.5 19.375H19.5C19.8125 19.375 20.125 19.1016 20.125 18.75V15.9375H9.5V19.375ZM20.125 14.0625V10.9375H9.5V14.0625H20.125ZM2 6.25C2 4.88281 3.09375 3.75 4.5 3.75H19.5C20.8672 3.75 22 4.88281 22 6.25V18.75C22 20.1562 20.8672 21.25 19.5 21.25H4.5C3.09375 21.25 2 20.1562 2 18.75V6.25Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavResult);
export default __webpack_public_path__ + "static/media/navResult.0ec7b71125e566b92f661fcb9971d0d5.svg";
export { ForwardRef as ReactComponent };